/**
 * Klaviyo out-of-stock form toggle (product page).
 *
 * Shows the Klaviyo "back in stock" embed form only while the add-to-cart
 * button is disabled (out of stock), by toggling the .klaviyo-block--hidden
 * class — defined in assets/custom-styles.css. A class is used instead of
 * display:none so the element stays in the render tree, which prevents Safari
 * from re-triggering Klaviyo's embed to inject a duplicate child div.
 *
 * Previously inlined in a "custom" theme block in templates/product.json;
 * moved here so it can't be edited or removed from the theme editor.
 */
(function () {
  const initKlaviyoToggle = () => {
    const atcBtn = document.querySelector('.btn--full.add-to-cart');
    if (!atcBtn) return false;

    const sync = () => {
      const block = document.querySelector('.klaviyo-form')?.closest('.product-block');
      if (!block) return;
      const isOos = atcBtn.hasAttribute('disabled') || atcBtn.classList.contains('disabled');
      // Toggle a CSS class instead of display:none — keeping the element in the render
      // tree prevents Safari from triggering Klaviyo's embed to re-inject a new child div
      block.classList.toggle('klaviyo-block--hidden', !isOos);
    };

    new MutationObserver(sync).observe(atcBtn, { attributes: true, attributeFilter: ['class', 'disabled'] });

    const domObserver = new MutationObserver(() => {
      const block = document.querySelector('.klaviyo-form')?.closest('.product-block');
      if (block) { sync(); domObserver.disconnect(); }
    });
    domObserver.observe(document.body, { childList: true, subtree: true });

    sync();
    return true;
  };

  // Safety net: if Safari still manages to inject duplicate divs into .klaviyo-form,
  // keep only the most recently added one so the form never renders stacked copies
  const watchKlaviyoDuplicates = () => {
    const attach = () => {
      const form = document.querySelector('.klaviyo-form');
      if (!form) return false;
      new MutationObserver(() => {
        const divs = Array.from(form.children).filter((el) => el.tagName === 'DIV');
        if (divs.length > 1) divs.slice(0, -1).forEach((div) => div.remove());
      }).observe(form, { childList: true });
      return true;
    };
    if (!attach()) {
      const iv = setInterval(() => { if (attach()) clearInterval(iv); }, 300);
    }
  };

  watchKlaviyoDuplicates();

  if (!initKlaviyoToggle()) {
    const iv = setInterval(() => { if (initKlaviyoToggle()) clearInterval(iv); }, 300);
  }
})();
